var bt = Object.defineProperty;
var xt = (e, l, t) => l in e ? bt(e, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[l] = t;
var Qe = (e, l, t) => xt(e, typeof l != "symbol" ? l + "" : l, t);
import { defineComponent as me, computed as N, unref as we, renderSlot as oe, normalizeProps as ue, mergeProps as se, createElementVNode as de, normalizeClass as ce, toDisplayString as Oe, openBlock as $, createElementBlock as P, normalizeStyle as $e, Fragment as K, renderList as Q, createBlock as le, resolveDynamicComponent as Ce, useSlots as Ct, ref as F, getCurrentInstance as It, watch as ae, onMounted as Et, onUpdated as Mt, onBeforeUnmount as Ot, withCtx as Ie, guardReactiveProps as Ee, createCommentVNode as Me, createVNode as $t } from "vue";
var T = /* @__PURE__ */ ((e) => (e.play = "play", e.playing = "playing", e.paused = "paused", e.hovered = "hovered", e.focused = "focused", e.update = "update", e.leave = "leave", e.blur = "blur", e))(T || {}), rt = /* @__PURE__ */ ((e) => (e.ondemand = "ondemand", e.progressive = "progressive", e))(rt || {}), A = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e.up = "up", e.down = "down", e.vertical = "vertical", e))(A || {}), W = /* @__PURE__ */ ((e) => (e.next = "next", e.previous = "previous", e))(W || {}), re = /* @__PURE__ */ ((e) => (e.auto = "auto", e.manual = "manual", e))(re || {});
const ze = (e) => e.flatMap(
  (l) => zt(l) ? [l] : Array.isArray(l.children) && l.children.length > 0 ? ze(l.children) : []
);
function zt(e) {
  return !e.type.toString().startsWith("Symbol");
}
const Nt = (e, l, t) => {
  var a;
  return (a = e.target) != null && a.tagName.match("TEXTAREA|INPUT|SELECT") || !l ? "" : e.key === "ArrowLeft" ? t ? W.next : W.previous : e.key === "ArrowRight" ? t ? W.previous : W.next : "";
}, Wt = (e, l) => {
  let t;
  const {
    centerMode: a,
    groupsToShow: n,
    groupsToScroll: s,
    slideGroupCount: c,
    currentSlideGroupIndex: m,
    infinite: L,
    infiniteLoopOnEdge: G,
    pivotSlideGroupIndices: h,
    currentPage: S
  } = e;
  if (l.message === W.previous)
    h[S] !== m ? t = h[S] : S === 0 ? a || G ? t = m - 1 : t = -n : t = h[S - 1];
  else if (l.message === W.next)
    S === h.length - 1 ? a || G ? t = m + 1 : t = c + (c % s === 0 ? 0 : n) : t = h[S + 1];
  else if (l.message === "dots") {
    if (t = h[l.index || 0], t === m)
      return null;
  } else if (l.message === "children") {
    if (t = l.index || 0, t === m)
      return null;
    if (L) {
      let d = Dt({ ...e, targetSlideGroupIndex: t });
      t > m && d === "left" ? t = t - c : t < m && d === "right" && (t = t + c);
    }
  } else if (l.message === "index" && (t = Number(l.index), t === m))
    return null;
  return t;
}, Dt = (e) => e.targetSlideGroupIndex > e.currentSlideGroupIndex ? e.targetSlideGroupIndex > e.currentSlideGroupIndex + Pt(e) ? "left" : "right" : e.targetSlideGroupIndex < e.currentSlideGroupIndex - At(e) ? "right" : "left", Pt = ({
  groupsToShow: e,
  centerMode: l,
  rtl: t,
  centerPadding: a
}) => {
  if (l) {
    let n = (e - 1) / 2 + 1;
    return parseInt(a) > 0 && (n += 1), t && e % 2 === 0 && (n += 1), n;
  }
  return t ? 0 : e - 1;
}, At = ({
  groupsToShow: e,
  centerMode: l,
  rtl: t,
  centerPadding: a
}) => {
  if (l) {
    let n = (e - 1) / 2 + 1;
    return parseInt(a) > 0 && (n += 1), !t && e % 2 === 0 && (n += 1), n;
  }
  return t ? e - 1 : 0;
}, Ht = (e) => {
  let l = e.infinite ? e.slideGroupCount * 2 : e.slideGroupCount, t = e.infinite ? e.groupsToShow * -1 : 0, a = e.infinite ? e.groupsToShow * -1 : 0, n = [];
  for (; t < l; )
    n.push(t), t = a + e.groupsToScroll, a += Math.min(e.groupsToScroll, e.groupsToShow);
  return n;
}, Ze = (e, l) => {
  const t = Ht(e);
  let a = 0;
  if (l > t[t.length - 1])
    l = t[t.length - 1];
  else
    for (let n in t) {
      if (l < t[n]) {
        l = a;
        break;
      }
      a = t[n];
    }
  return l;
}, Bt = (e, l, t) => {
  if (!(!l || !t && e.type.indexOf("mouse") !== -1))
    return {
      dragging: !0,
      touchObject: {
        startX: window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageX : e.clientX,
        startY: window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageY : e.clientY,
        curX: window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageX : e.clientX,
        curY: window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageY : e.clientY
      }
    };
}, Je = (e) => {
  var L;
  const l = e.centerMode ? +e.slideGroupWidth * Math.floor(e.groupsToShow / 2) : 0;
  let t;
  const n = e.listEl.querySelectorAll(
    ".v-slick-slide-group"
  );
  if (Array.from(n).every((G) => {
    if (e.vertical) {
      if (G.offsetTop + G.offsetHeight / 2 > e.swipeLeft * -1)
        return t = G, !1;
    } else if (G.offsetLeft - l + G.offsetWidth / 2 > e.swipeLeft * -1)
      return t = G, !1;
    return !0;
  }), !t)
    return 0;
  const s = e.rtl === !0 ? e.slideGroupCount - e.currentSlideGroupIndex : e.currentSlideGroupIndex, c = (L = t == null ? void 0 : t.dataset) == null ? void 0 : L.index;
  return Math.abs(
    c ? parseInt(c) : 0 - s
  );
}, ot = (e, l = !1) => {
  let t, a, n, s;
  return t = e.startX - e.curX, a = e.startY - e.curY, n = Math.atan2(a, t), s = Math.round(n * 180 / Math.PI), s < 0 && (s = 360 - Math.abs(s)), s <= 45 && s >= 0 || s <= 360 && s >= 315 ? A.left : s >= 135 && s <= 225 ? A.right : l === !0 ? s >= 35 && s <= 135 ? A.up : A.down : A.vertical;
}, Rt = (e, l) => {
  const {
    dragging: t,
    swipe: a,
    touchObject: n,
    listWidth: s,
    touchThreshold: c,
    verticalSwiping: m,
    listHeight: L,
    currentSlideGroupIndex: G,
    swipeToSlide: h,
    scrolling: S,
    onSwipe: d,
    rtl: k
  } = l;
  if (!t) {
    a && e.cancelable && e.preventDefault();
    return;
  }
  let f = m ? L / c : s / c, w = ot(n, m);
  k && (w === A.left ? w = A.right : w === A.right && (w = A.left));
  let M = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (S || !n.swipeLength)
    return M;
  if (n.swipeLength > f) {
    e.cancelable && e.preventDefault(), d && d(w);
    let y, I;
    switch (w) {
      case "left":
      case "up":
        I = l.swipeToSlide ? Je(l) : G + l.groupsToScroll, y = h ? Ze(l, I) : I, M.currentDirection = 0;
        break;
      case "right":
      case "down":
        I = l.swipeToSlide ? Je(l) : G - l.groupsToScroll, y = h ? Ze(l, I) : I, M.currentDirection = 1;
        break;
      default:
        y = G;
    }
    M.triggerSlideGroupHandler = y;
  } else {
    let y = pe(l);
    M.trackStyle = nt(l, y);
  }
  return M;
};
function Vt(e) {
  return e.centerMode ? Math.floor(e.groupsToShow / 2) + (parseInt(e.centerPadding) > 0 ? 1 : 0) : 0;
}
function _t(e) {
  return e.centerMode ? Math.floor((e.groupsToShow - 1) / 2) + 1 + (parseInt(e.centerPadding) > 0 ? 1 : 0) : e.groupsToShow;
}
function lt(e) {
  return e.currentSlideGroupIndex - Vt(e);
}
function it(e) {
  return e.currentSlideGroupIndex + _t(e);
}
function De(e) {
  var n;
  let l = [];
  const t = lt(e), a = it(e);
  for (let s = t; s < a; s++)
    ((n = e.lazyLoadedList) == null ? void 0 : n.indexOf(s)) < 0 && l.push(s);
  return l;
}
function fe(e, l) {
  let t, a;
  const n = e.slideGroupCount + 2 * e.groupsToShow;
  e.vertical ? a = n * parseInt(`${e.slideGroupHeight || 0}`) : t = jt(e) * parseInt(`${e.slideGroupWidth || 0}`);
  let s = {
    opacity: 1,
    transition: ""
  };
  if (e.useCSSTransform) {
    if (e.slideGroupCount > e.groupsToShow || e.infinite && e.infiniteLoopOnEdge) {
      let c = e.vertical ? "translate3d(0px, " + l + "px, 0px)" : "translate3d(" + l + "px, 0px, 0px)";
      s = {
        ...s,
        transform: c
      };
    }
  } else
    e.vertical ? s.top = l : s.left = l;
  return e.fade && (s = { opacity: 1 }), t && (s.width = t + "px"), a && (s.height = a + "px"), s;
}
function jt(e) {
  return e.slideGroupCount <= e.groupsToShow ? e.slideGroupCount : Z(e) + e.slideGroupCount + Ne(e);
}
function nt(e, l) {
  let t = fe(e, l);
  return e.useCSSTransform ? t.transition = "transform " + e.speed + "ms " + e.cssEase : e.vertical ? t.transition = "top " + e.speed + "ms " + e.cssEase : t.transition = "left " + e.speed + "ms " + e.cssEase, e.ignorePrefersReducedMotion && (t.transition += " !important"), t;
}
function pe(e) {
  let {
    centerPadding: l,
    currentSlideGroupIndex: t,
    trackEl: a,
    infinite: n,
    centerMode: s,
    slideGroupCount: c,
    groupsToShow: m,
    groupsToScroll: L,
    slideGroupWidth: G,
    listWidth: h,
    variableWidth: S,
    slideGroupHeight: d,
    fade: k,
    vertical: f,
    rtl: w
  } = e;
  h = h || 0, G = G || 0, d = d || 0;
  let M = 0, y, I, _ = 0;
  if (k || c === 1)
    return 0;
  let B = 0;
  if (n ? (B = -Z(e), c % L !== 0 && t + L > c && (B = -(t > c ? m - (t - c) : c % L)), s && (B += Math.floor(m / 2))) : (c % L !== 0 && t + L > c && (B = m - c % L), s && (B = Math.floor(m / 2))), M = B * parseInt(`${G}`), _ = B * parseInt(`${d}`), f ? y = t * parseInt(`${d}`) * -1 + _ : y = t * parseInt(`${G}`) * -1 + M, S) {
    let D;
    D = t + Z(e);
    const R = Array.from((a == null ? void 0 : a.childNodes) || []).filter(
      (O) => {
        var H;
        return (H = O == null ? void 0 : O.classList) == null ? void 0 : H.contains("v-slick-slide-group");
      }
    );
    if (I = a && R[D], y = I ? I.offsetLeft * -1 : 0, s) {
      if (D = n ? t + Z(e) : t, y = 0, a) {
        I = a.children[D];
        for (let O = 0; O < D; O++)
          a.children[O] && (y -= a.children[O].offsetWidth);
      }
      y -= parseInt(l), I && (y += h - I.offsetWidth / 2);
    }
  }
  return w && (y = -y), y;
}
const Xt = (e) => {
  let {
    waitForAnimate: l,
    animating: t,
    fade: a,
    infinite: n,
    index: s,
    slideGroupCount: c,
    lazyLoadedList: m,
    lazyLoad: L,
    currentSlideGroupIndex: G,
    centerMode: h,
    groupsToScroll: S,
    groupsToShow: d,
    useCSSTransitions: k
  } = e;
  if (l && t || a && !n && (s < 0 || s >= c))
    return;
  let f = s, w, M = {}, y = {};
  if (a)
    return s < 0 ? f += c : s >= c && (f -= c), L && m.indexOf(f) < 0 && m.push(f), M = {
      animating: !0,
      currentSlideGroupIndex: f,
      lazyLoadedList: m
    }, y = { animating: !1 }, {
      slidingState: M,
      afterSlidingState: y
    };
  w = f, f < 0 ? (w = f + c, n ? c % S !== 0 && (w = c - c % S) : w = 0) : !e.canGoNext && f > G ? f = w = G : h && f >= c ? (f = n ? c : c - 1, w = n ? 0 : c - 1) : f >= c && (w = f - c, n ? c % S !== 0 && (w = 0) : w = c - d);
  let I = pe({
    ...e,
    currentSlideGroupIndex: w
  }), _ = pe({
    ...e,
    currentSlideGroupIndex: f
  });
  return n || (_ === I && (f = w), _ = I), L && (m = m.concat(
    De({
      ...e,
      currentSlideGroupIndex: f
    })
  )), k ? (M = {
    animating: !0,
    currentSlideGroupIndex: w,
    trackStyle: nt(e, _),
    lazyLoadedList: m
  }, y = {
    animating: !1,
    currentSlideGroupIndex: w,
    trackStyle: fe(e, I),
    swipeLeft: void 0
  }, { slidingState: M, afterSlidingState: y }) : (M = {
    currentSlideGroupIndex: w,
    trackStyle: fe(e, I),
    lazyLoadedList: m
  }, {
    slidingState: M,
    afterSlidingState: y
  });
};
function Z(e) {
  return e.infinite ? e.variableWidth ? e.slideGroupCount : e.groupsToShow + (e.centerMode ? 1 : 0) : 0;
}
function Ne(e) {
  return e.infinite ? e.slideGroupCount : 0;
}
const Yt = (e, l) => {
  const {
    scrolling: t,
    animating: a,
    vertical: n,
    swipeToSlide: s,
    verticalSwiping: c,
    rtl: m,
    currentSlideGroupIndex: L,
    edgeFriction: G,
    edgeDragged: h,
    onEdge: S,
    swiped: d,
    swiping: k,
    slideGroupCount: f,
    groupsToScroll: w,
    infinite: M,
    touchObject: y,
    swipeEvent: I,
    listHeight: _,
    listWidth: B
  } = l;
  if (t) return;
  if (a) {
    e.cancelable && e.preventDefault();
    return;
  }
  n && s && c && e.cancelable && e.preventDefault();
  let D, R = {}, O = pe(l);
  y.curX = window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageX : e.clientX, y.curY = window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageY : e.clientY, y.swipeLength = Math.round(
    Math.sqrt(Math.pow(y.curX - y.startX, 2))
  );
  let H = Math.round(
    Math.sqrt(Math.pow(y.curY - y.startY, 2))
  );
  if (!c && !k && H > 10)
    return { scrolling: !0 };
  c && (y.swipeLength = H);
  let j = (m ? -1 : 1) * (y.curX > y.startX ? 1 : -1);
  c && (j = y.curY > y.startY ? 1 : -1);
  let Ge = Math.ceil(f / w), X = ot(l.touchObject, c), U = y.swipeLength;
  return M || (L === 0 && X === "right" || L + 1 >= Ge && X === "left" || !l.canGoNext && X === "left") && (U = Math.round(y.swipeLength * G), h === !1 && S && (S(X), R.edgeDragged = !0)), !d && I && (I(X), R.swiped = !0), n ? D = O + U * (_ / B) * j : m ? D = O - U * j : D = O + U * j, c && (D = O + U * j), R = {
    ...R,
    touchObject: y,
    swipeLeft: D,
    trackStyle: fe(l, D),
    swipeDirection: X
  }, Math.abs(y.curX - y.startX) < Math.abs(y.curY - y.startY) * 0.8 || y.swipeLength > 10 && (R.swiping = !0, e.cancelable && e.preventDefault()), R;
};
function at(e, l) {
  return Math.ceil(e / l);
}
function qt(e) {
  var S, d, k;
  let l = at(
    e.slides.length,
    e.groupsToShow
  ), t = Math.ceil(((S = e.listEl) == null ? void 0 : S.offsetWidth) || 0), a = Math.ceil(((d = e.trackEl) == null ? void 0 : d.offsetWidth) || 0), n;
  if (e.vertical)
    n = t;
  else {
    let f = e.centerMode ? parseInt(e.centerPadding) * 2 : 0;
    typeof e.centerPadding == "string" && e.centerPadding.slice(-1) === "%" && (f *= t / 100), n = Math.ceil(
      (t - f) / e.groupsToShow
    );
  }
  let s = e.listEl && e.listEl.querySelector('[data-index="0"]') && ((k = e.listEl.querySelector('[data-index="0"]')) == null ? void 0 : k.offsetHeight) || 0, c = s * e.groupsToShow, m = e.currentSlideGroupIndex === void 0 ? e.initialGroupIndex : e.currentSlideGroupIndex;
  e.rtl && e.currentSlideGroupIndex === void 0 && (m = l - 1 - e.initialGroupIndex);
  let L = e.lazyLoadedList || [], G = De(e);
  L.concat(G);
  let h = {
    slideGroupCount: l,
    slideGroupWidth: n,
    listWidth: t,
    trackWidth: a,
    currentSlideGroupIndex: m,
    slideGroupHeight: s,
    listHeight: c,
    lazyLoadedList: L
  };
  return e.autoplaying === null && e.autoplay && (h.autoplaying = T.playing), h;
}
class Ft {
  constructor() {
    Qe(this, "mqlRecords", {});
  }
  register(l, t) {
    this.mqlRecords[l] ? this.addMqlListener(l, t) : (this.mqlRecords[l] = window.matchMedia(l), this.addMqlListener(l, t)), this.mqlRecords[l].matches && t({ matches: !0 });
  }
  unregister(l, t) {
    this.mqlRecords[l] && this.removeMqlListener(l, t);
  }
  addMqlListener(l, t) {
    try {
      this.mqlRecords[l].addEventListener("change", t);
    } catch {
      try {
        this.mqlRecords[l].addListener(t);
      } catch (n) {
        console.error(n);
      }
    }
  }
  removeMqlListener(l, t) {
    try {
      this.mqlRecords[l].removeEventListener("change", t);
    } catch {
      try {
        this.mqlRecords[l].removeListener(t);
      } catch (n) {
        console.error(n);
      }
    }
  }
}
const Ut = () => !!(typeof window < "u" && window.document && window.document.createElement), et = (e) => Object.keys(e).filter((l) => e[l] !== void 0).reduce((l, t) => (l[t] = e[t], l), {});
function Kt() {
  var e, l;
  window.getSelection && ((e = window.getSelection()) != null && e.empty ? window.getSelection().empty() : (l = window.getSelection()) != null && l.removeAllRanges && window.getSelection().removeAllRanges());
}
function Qt(e) {
  return Object.keys(e).map((t) => {
    let a = e[t];
    return Array.isArray(a) && (a = a.join(" and ")), `(${t}: ${a})`;
  }).join(" and ");
}
function Zt(e, l) {
  const t = setTimeout(e, l);
  return { cancel: () => clearTimeout(t) };
}
const ke = (e) => {
  const l = {
    accessibility: { type: Boolean, default: !0 },
    adaptiveHeight: { type: Boolean, default: !1 },
    arrows: { type: Boolean, default: !0 },
    asNavFor: {
      type: Object,
      default: null
    },
    autoplay: { type: Boolean, default: !1 },
    autoplaySpeed: { type: Number, default: 3e3 },
    centerMode: { type: Boolean, default: !1 },
    centerPadding: { type: String, default: "50px" },
    cssEase: { type: String, default: "ease" },
    dots: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !0 },
    edgeFriction: { type: Number, default: 0.35 },
    fade: { type: Boolean, default: !1 },
    focusOnSelect: { type: Boolean, default: !1 },
    ignorePrefersReducedMotion: { type: Boolean, default: !1 },
    infinite: { type: Boolean, default: !0 },
    infiniteLoopOnEdge: { type: Boolean, default: !1 },
    initialGroupIndex: { type: Number, default: 0 },
    lazyLoad: { type: String, default: null },
    nextArrowLabel: { type: String, default: "Next" },
    pauseOnDotsHover: { type: Boolean, default: !1 },
    pauseOnFocus: { type: Boolean, default: !1 },
    pauseOnHover: { type: Boolean, default: !0 },
    prevArrowLabel: { type: String, default: "Previous" },
    responsive: { type: Array, default: [] },
    responsiveBehavior: {
      type: String,
      default: "mobile-first"
    },
    rtl: { type: Boolean, default: !1 },
    slidesPerGroup: { type: Number, default: 1 },
    groupsToScroll: { type: Number, default: 1 },
    groupsToShow: { type: Number, default: 1 },
    speed: { type: Number, default: 500 },
    swipe: { type: Boolean, default: !0 },
    swipeToSlide: { type: Boolean, default: !1 },
    touchMove: { type: Boolean, default: !0 },
    touchThreshold: { type: Number, default: 5 },
    unslick: { type: Boolean, default: !1 },
    useCSSTransitions: { type: Boolean, default: !0 },
    useCSSTransform: { type: Boolean, default: !0 },
    variableWidth: { type: Boolean, default: !1 },
    vertical: { type: Boolean, default: !1 },
    verticalSwiping: { type: Boolean, default: !1 },
    waitForAnimate: { type: Boolean, default: !0 },
    widthDetection: { type: String, default: re.auto }
  };
  return e ? Object.keys(l).reduce((t, a) => (e.includes(a) && (t[a] = l[a]), t), {}) : l;
}, We = ke(), Jt = Object.keys(We).reduce((e, l) => (e[l] = We[l].default, e), {}), er = () => ({
  animating: !1,
  autoplaying: null,
  autoplayTimer: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlideGroupIndex: 0,
  detectingWidth: !1,
  direction: 1,
  dragging: !1,
  edgeDragged: !1,
  initialized: !1,
  lazyLoadedList: [],
  listHeight: void 0,
  listWidth: void 0,
  scrolling: !1,
  slideGroupHeight: void 0,
  slideGroupWidth: void 0,
  swipeLeft: void 0,
  swiped: !1,
  swiping: !1,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0, swipeLength: 0 },
  trackStyle: {},
  trackWidth: 0
}), tr = {
  ...ke([
    "centerMode",
    "centerPadding",
    "cssEase",
    "fade",
    "ignorePrefersReducedMotion",
    "infinite",
    "infiniteLoopOnEdge",
    "lazyLoad",
    "rtl",
    "groupsToScroll",
    "groupsToShow",
    "speed",
    "variableWidth",
    "vertical"
  ]),
  currentSlideGroupIndex: { type: Number, default: 0 },
  detectingWidth: { type: Boolean, default: !1 },
  lazyLoadedList: {
    type: Array,
    default: []
  },
  listHeight: { type: Number, default: void 0 },
  trackStyle: { type: Object, default: {} },
  slideGroupCount: { type: Number, default: 0 },
  rawSlideGroups: { type: Array, default: [] },
  slideGroupHeight: { type: [String, Number], default: void 0 },
  slideGroupWidth: { type: [String, Number], default: void 0 }
}, rr = {
  ...ke([
    "centerMode",
    "infinite",
    "groupsToShow",
    "prevArrowLabel",
    "nextArrowLabel"
  ]),
  currentSlideGroupIndex: { type: Number, default: 0 },
  disabled: { type: Boolean, default: !1 },
  slideGroupCount: { type: Number, default: 0 },
  type: { type: String, default: "prev" }
}, or = {
  ...ke(["infinite", "groupsToScroll", "groupsToShow"]),
  currentSlideGroupIndex: { type: Number, default: 0 },
  slideGroupCount: { type: Number, default: 0 },
  pageCount: { type: Number, default: 0 },
  currentPage: { type: Number, default: 0 }
}, lr = /* @__PURE__ */ me({
  __name: "VSlickArrow",
  props: rr,
  emits: [W.previous, W.next],
  setup(e, { emit: l }) {
    const t = e, a = l, n = N(() => () => {
      t.disabled || a(t.type);
    }), s = N(() => ({
      currentSlideGroupIndex: t.currentSlideGroupIndex,
      slideGroupCount: t.slideGroupCount,
      onClick: n.value,
      disabled: !t.disabled
    }));
    return (c, m) => c.type === we(W).previous ? oe(c.$slots, "prevArrow", ue(se({ key: 0 }, s.value)), () => [
      de("button", {
        type: "button",
        "data-role": "none",
        class: ce(["v-slick-arrow prev", { disabled: c.disabled }]),
        onClick: m[0] || (m[0] = //@ts-ignore
        (...L) => n.value && n.value(...L))
      }, Oe(c.prevArrowLabel), 3)
    ], !0) : oe(c.$slots, "nextArrow", ue(se({ key: 1 }, s.value)), () => [
      de("button", {
        type: "button",
        "data-role": "none",
        class: ce(["v-slick-arrow next", { disabled: c.disabled }]),
        onClick: m[1] || (m[1] = //@ts-ignore
        (...L) => n.value && n.value(...L))
      }, Oe(c.nextArrowLabel), 3)
    ], !0);
  }
}), Pe = (e, l) => {
  const t = e.__vccOpts || e;
  for (const [a, n] of l)
    t[a] = n;
  return t;
}, tt = /* @__PURE__ */ Pe(lr, [["__scopeId", "data-v-1ed7a297"]]), ir = ["onClick"], nr = ["onClick"], ar = ["onClick"], ur = /* @__PURE__ */ me({
  __name: "VSlickTrack",
  props: tr,
  emits: ["childClick"],
  setup(e, { emit: l }) {
    const t = e, a = l, n = (h) => {
      let S = !1, d = !1, k = !1, f;
      return t.centerMode ? (f = Math.floor(t.groupsToShow / 2), d = (h - t.currentSlideGroupIndex) % t.slideGroupCount === 0, h > t.currentSlideGroupIndex - f - 1 && h <= t.currentSlideGroupIndex + f && (S = !0)) : S = t.currentSlideGroupIndex <= h && h < t.currentSlideGroupIndex + t.groupsToShow, k = h === t.currentSlideGroupIndex, Object.entries({
        active: S,
        center: d,
        current: k
      }).filter(([, w]) => w).map(([w]) => w);
    }, s = (h) => {
      let S = {};
      if ((t.variableWidth === void 0 || t.variableWidth === !1) && (S.width = typeof t.slideGroupWidth == "number" ? `${t.slideGroupWidth}px` : t.slideGroupWidth), t.fade) {
        if (S.position = "relative", t.vertical) {
          const d = t.slideGroupHeight ? typeof t.slideGroupHeight == "string" ? parseFloat(t.slideGroupHeight) : t.slideGroupHeight : 0;
          S.top = `${-h * d}px`;
        } else {
          const d = t.slideGroupWidth ? typeof t.slideGroupWidth == "string" ? parseFloat(t.slideGroupWidth) : t.slideGroupWidth : 0, k = t.rtl ? h * d : -h * d;
          S.left = `${k}px`;
        }
        S.opacity = t.currentSlideGroupIndex === h ? 1 : 0, S.transition = "opacity " + t.speed + "ms " + t.cssEase + ", visibility " + t.speed + "ms " + t.cssEase, t.ignorePrefersReducedMotion && (S.transition += " !important");
      }
      return S;
    }, c = N(() => t.rawSlideGroups.map((S, d) => {
      const k = s(d), f = n(d);
      t.fade && f.includes("active") && Object.assign(k, { zIndex: 1 });
      const w = {
        slides: [],
        key: `original-${d}`,
        class: f,
        style: k,
        attrs: {
          "data-index": d,
          ...f.includes("active") ? {} : { inert: "true" }
        },
        onClick: () => {
          a("childClick", {
            index: t.rtl && t.infinite ? t.slideGroupCount + d : d
          });
        }
      };
      return (!t.lazyLoad || t.lazyLoad && t.lazyLoadedList.indexOf(d) >= 0) && (w.slides = S), w;
    })), m = N(() => t.infinite && !t.fade && (t.slideGroupCount > t.groupsToShow || t.infiniteLoopOnEdge && t.slideGroupCount >= t.groupsToShow)), L = N(() => m.value ? t.rawSlideGroups.map((S, d) => {
      const k = t.slideGroupCount - d;
      if (k > Z(t)) return;
      const f = -k, w = {
        slides: [],
        key: `preclone-${f}`,
        class: n(f),
        style: s(d),
        attrs: {
          "data-index": f,
          inert: "true"
        },
        onClick: () => {
          a("childClick", {
            index: f
          });
        }
      };
      return (f >= lt(t) || !t.lazyLoad || t.lazyLoad && t.lazyLoadedList.indexOf(d) >= 0) && (w.slides = S), w;
    }).filter((S) => S) : []), G = N(() => m.value ? t.rawSlideGroups.map((S, d) => {
      const k = t.slideGroupCount + d, f = {
        slides: [],
        key: `postclone-${k}`,
        class: n(k),
        style: s(d),
        attrs: {
          "data-index": k,
          ...t.infinite && t.slideGroupCount - t.currentSlideGroupIndex < t.groupsToShow && d < t.groupsToShow - (t.slideGroupCount - t.currentSlideGroupIndex) ? {} : { inert: "true" }
        },
        onClick: () => {
          a("childClick", {
            index: t.rtl ? t.slideGroupCount + k : k
          });
        }
      };
      return (k < it(t) || !t.lazyLoad || t.lazyLoad && t.lazyLoadedList.indexOf(d) >= 0) && (f.slides = S), f;
    }) : []);
    return (h, S) => ($(), P("div", {
      class: ce(["v-slick-track", { center: h.centerMode, vertical: h.vertical }]),
      style: $e([h.trackStyle, h.detectingWidth ? { width: "0 !important" } : {}])
    }, [
      ($(!0), P(K, null, Q(L.value, (d, k) => ($(), P("div", se({
        key: d.key,
        tabindex: "-1",
        class: [d.class, "v-slick-slide-group clone"],
        style: d.style,
        ref_for: !0
      }, d.attrs, {
        onClick: d.onClick
      }), [
        ($(!0), P(K, null, Q(d.slides, (f, w) => ($(), le(Ce(f), {
          key: `slide-${k}-${w}` + (f.key ? `-${String(f.key)}` : "")
        }))), 128))
      ], 16, ir))), 128)),
      ($(!0), P(K, null, Q(c.value, (d, k) => ($(), P("div", se({
        key: d.key,
        tabindex: "-1",
        class: ["v-slick-slide-group", d.class],
        style: d.style,
        ref_for: !0
      }, d.attrs, {
        onClick: d.onClick
      }), [
        ($(!0), P(K, null, Q(d.slides, (f, w) => ($(), le(Ce(f), {
          key: `slide-${k}-${w}` + (f.key ? `-${String(f.key)}` : "")
        }))), 128))
      ], 16, nr))), 128)),
      ($(!0), P(K, null, Q(G.value, (d, k) => ($(), P("div", se({
        key: d.key,
        tabindex: "-1",
        class: [d.class, "v-slick-slide-group clone"],
        style: d.style,
        ref_for: !0
      }, d.attrs, {
        onClick: d.onClick
      }), [
        ($(!0), P(K, null, Q(d.slides, (f, w) => ($(), le(Ce(f), {
          key: `slide-${k}-${w}` + (f.key ? `-${String(f.key)}` : "")
        }))), 128))
      ], 16, ar))), 128))
    ], 6));
  }
}), sr = /* @__PURE__ */ Pe(ur, [["__scopeId", "data-v-c00ba6bb"]]), dr = ["onClick"], cr = /* @__PURE__ */ me({
  __name: "VSlickDots",
  props: or,
  emits: ["dotClick", "dotsOver", "dotsLeave"],
  setup(e) {
    const l = e, t = (a) => a === l.currentPage;
    return (a, n) => ($(), P("ul", {
      class: "v-slick-dots",
      style: { display: "block" },
      onMouseenter: n[0] || (n[0] = (s) => a.$emit("dotsLeave")),
      onMouseleave: n[1] || (n[1] = (s) => a.$emit("dotsLeave")),
      onMouseover: n[2] || (n[2] = (s) => a.$emit("dotsOver"))
    }, [
      ($(!0), P(K, null, Q(a.pageCount, (s) => ($(), P("li", {
        key: s,
        class: ce({ active: t(s - 1) }),
        onClick: (c) => a.$emit("dotClick", {
          index: s - 1,
          groupsToScroll: a.groupsToScroll
        })
      }, [
        oe(a.$slots, "customPaging", {
          page: s - 1
        }, () => [
          de("button", null, Oe(s), 1)
        ])
      ], 10, dr))), 128))
    ], 32));
  }
}), fr = ["dir"], pr = 50, vr = /* @__PURE__ */ me({
  inheritAttrs: !1,
  __name: "VSlickCarousel",
  props: We,
  emits: [
    "init",
    "beforeChange",
    "afterChange",
    "lazyLoad",
    "lazyLoadError",
    "reInit",
    "edge",
    "swipe"
  ],
  setup(e, { expose: l, emit: t }) {
    var Fe, Ue, Ke;
    const a = e, n = t, s = Ct(), c = Ut() ? new Ft() : void 0;
    let m, L = null, G = null, h = [];
    const S = F({
      ...((Ke = (Ue = (Fe = It()) == null ? void 0 : Fe.vnode) == null ? void 0 : Ue.props) == null ? void 0 : Ke.style) || {}
    });
    let d = !0, k = null, f = null, w = [];
    const M = (i, o, p) => {
      if (!c) return;
      const g = (v) => {
        v.matches ? o() : p();
      };
      c.register(i, g), w.push({ query: i, handler: g });
    }, y = () => {
      w.forEach(
        ({ query: i, handler: o }) => c == null ? void 0 : c.unregister(i, o)
      ), w = [];
    }, I = () => {
      if (!a.responsive.length) return;
      let i = "min-width";
      a.responsiveBehavior === "desktop-first" && (i = "max-width");
      const o = a.responsive.map((p) => p.breakpoint);
      o.sort(
        (p, g) => a.responsiveBehavior === "desktop-first" ? g - p : p - g
      ), o.forEach((p, g) => {
        const v = Qt({
          [i]: `${p}px`
        });
        M(
          v,
          () => {
            ge.value = p;
          },
          () => {
            ge.value = g === 0 ? void 0 : o[g - 1];
          }
        );
      });
    }, _ = (i) => {
      setTimeout(() => {
        i.cancelable && i.preventDefault();
      });
      const o = Bt(
        i,
        r.value.swipe,
        r.value.draggable
      );
      Object.assign(u.value, o);
    }, B = (i) => {
      var v;
      const o = Rt(i, {
        ...r.value,
        ...u.value,
        trackEl: (v = q.value) == null ? void 0 : v.$el,
        listEl: E.value,
        slideGroupIndex: u.value.currentSlideGroupIndex,
        slideGroupCount: x.value
      });
      if (!o) return;
      const { triggerSlideGroupHandler: p, ...g } = o;
      m = p, Object.assign(u.value, g), m !== void 0 && ve(m);
    }, D = (i) => {
      var g;
      Kt();
      const { swipeDirection: o, ...p } = Yt(i, {
        ...r.value,
        ...u.value,
        trackEl: (g = q.value) == null ? void 0 : g.$el,
        listEl: E.value,
        slideGroupIndex: u.value.currentSlideGroupIndex,
        slideGroupCount: x.value,
        onEdge: (v) => n("edge", v),
        swipeEvent: (v) => n("swipe", v),
        canGoNext: ie.value
      }) || {};
      (r.value.verticalSwiping && o === A.up || o === A.down || !r.value.verticalSwiping && o === A.left || o === A.right) && i.cancelable && i.preventDefault(), p && (p.swiping && (d = !1), Object.assign(u.value, p));
    }, R = () => {
      let i;
      if (r.value.rtl)
        i = u.value.currentSlideGroupIndex - r.value.groupsToScroll;
      else if (ie.value)
        i = u.value.currentSlideGroupIndex + r.value.groupsToScroll;
      else
        return !1;
      ve(i);
    }, O = (i = null) => {
      u.value.autoplayTimer && (clearInterval(u.value.autoplayTimer), u.value.autoplayTimer = null);
      const o = u.value.autoplaying;
      i === T.paused ? u.value.autoplaying = T.paused : i === T.focused && (o === T.hovered || o === T.playing) ? u.value.autoplaying = T.focused : o === T.playing ? u.value.autoplaying = T.hovered : o === null && (u.value.autoplaying = null);
    }, H = (i) => {
      u.value.autoplayTimer && clearInterval(u.value.autoplayTimer);
      const o = u.value.autoplaying;
      if (i === T.update) {
        if (o === T.hovered || o === T.focused || o === T.paused)
          return;
      } else if (i === T.leave) {
        if (o === T.paused || o === T.focused)
          return;
      } else if (i === T.blur && (o === T.paused || o === T.hovered))
        return;
      u.value.autoplayTimer = setInterval(
        R,
        r.value.autoplaySpeed + 50
      ), u.value.autoplaying = T.playing;
    }, j = () => {
      if (r.value.adaptiveHeight && E.value) {
        const i = E.value.querySelectorAll(
          ".v-slick-slide-group.active"
        );
        let o = 0;
        i.forEach((p) => {
          o = Math.max(o, p.offsetHeight);
        }), E.value.style.height = o + "px";
      }
    }, Ge = () => {
      r.value.autoplay && O(T.hovered);
    }, X = () => {
      r.value.autoplay && u.value.autoplaying === T.hovered && H(T.leave);
    }, U = (i) => {
      d === !1 && (i.stopPropagation(), i.preventDefault()), d = !0;
    }, ut = ({ index: i }) => {
      !r.value.focusOnSelect || r.value.unslick || Y({
        message: "children",
        index: i
      });
    }, st = (i) => {
      if (!r.value.accessibility || r.value.unslick) return;
      const o = Nt(
        i,
        r.value.accessibility,
        r.value.rtl
      );
      o && Y({ message: o });
    }, Ae = (i) => {
      if (!r.value.touchMove || r.value.unslick) return;
      const o = i.target;
      o != null && o.classList.contains("no-swipe") || _(i);
    }, Te = (i) => {
      if (!u.value.dragging || !r.value.touchMove || r.value.unslick)
        return;
      const o = i.target;
      o != null && o.classList.contains("no-swipe") || D(i);
    }, Le = (i) => {
      !r.value.touchMove || r.value.unslick || B(i);
    }, be = (i) => {
      !u.value.dragging || !r.value.touchMove || r.value.unslick || B(i);
    }, He = () => {
      !r.value.pauseOnHover || r.value.unslick || Ge();
    }, dt = () => {
      !r.value.pauseOnHover || r.value.unslick || X();
    }, ct = () => {
      r.value.pauseOnDotsHover && r.value.autoplay && O(T.hovered);
    }, ft = () => {
      r.value.pauseOnDotsHover && r.value.autoplay && u.value.autoplaying === T.hovered && H(T.leave);
    }, pt = ({ index: i }) => {
      Y({
        message: "dots",
        index: i
      });
    }, vt = () => {
      Y({
        message: W.next
      });
    }, gt = () => {
      Y({
        message: W.previous
      });
    }, Y = (i, o = !1) => {
      const p = {
        ...r.value,
        ...u.value,
        slideGroupCount: x.value,
        pivotSlideGroupIndices: Ye.value,
        currentPage: Se.value
      }, g = Wt(
        p,
        i
      );
      g != null && ve(
        g,
        o === !0 ? !0 : void 0
      );
    }, ve = async (i, o = !1) => {
      var ye, ne;
      const { asNavFor: p, speed: g } = r.value, v = u.value.currentSlideGroupIndex, b = Xt({
        index: i,
        ...r.value,
        ...u.value,
        slideGroupCount: x.value,
        trackEl: (ye = q.value) == null ? void 0 : ye.$el,
        useCSSTransitions: r.value.useCSSTransitions && !o,
        canGoNext: ie.value
      });
      if (!b) return;
      const { slidingState: z, afterSlidingState: C } = b;
      n(
        "beforeChange",
        v,
        z.currentSlideGroupIndex
      );
      const V = ((ne = z.lazyLoadedList) == null ? void 0 : ne.filter(
        (te) => u.value.lazyLoadedList.indexOf(te) < 0
      )) || [];
      V.length && n("lazyLoad", V), Object.assign(u.value, z), p && p.goTo(i), C && await new Promise((te) => {
        L = setTimeout(() => {
          const { animating: Tt, ...Lt } = C;
          (r.value.waitForAnimate || u.value.currentSlideGroupIndex === z.currentSlideGroupIndex) && Object.assign(u.value, Lt), h.push(
            setTimeout(() => {
              u.value.animating = Tt || !1;
            })
          ), n("afterChange", z.currentSlideGroupIndex), L = null, te();
        }, g);
      });
    }, xe = (i) => {
      var b, z;
      const o = qt({
        ...r.value,
        ...u.value,
        listEl: E.value,
        trackEl: (b = q.value) == null ? void 0 : b.$el,
        slides: he.value
      }), p = {
        ...r.value,
        ...u,
        ...o,
        trackEl: (z = q.value) == null ? void 0 : z.$el,
        slideGroupCount: x.value
      }, g = pe(p), v = fe(p, g);
      (i || x.value !== p.slideGroupCount) && (o.trackStyle = v), Object.assign(u.value, o);
    }, ht = async (i = {
      shouldSetTrackStyle: !0
    }) => {
      !q.value || !q.value.$el || (r.value.widthDetection === re.manual && i.isWindowResize && await Re(), xe(
        i.shouldSetTrackStyle || r.value.widthDetection === re.manual && i.isWindowResize
      ), r.value.autoplay ? H(T.update) : O());
    }, J = (i) => {
      k == null || k.cancel(), k = Zt(() => ht(i), pr);
    }, Be = () => J({
      isWindowResize: !0
    }), St = () => {
      r.value.autoplay && O(T.focused);
    }, yt = () => {
      r.value.autoplay && u.value.autoplaying === T.focused && H(T.blur);
    }, wt = () => {
      const i = [], o = { ...r.value, ...u.value }, p = Ne({
        ...o,
        slideGroupCount: x.value
      }), g = Z({
        ...o,
        slideGroupCount: x.value
      });
      for (let v = u.value.currentSlideGroupIndex; v < x.value + p; v++)
        if (u.value.lazyLoadedList.indexOf(v) < 0) {
          i.push(v);
          break;
        }
      for (let v = u.value.currentSlideGroupIndex - 1; v >= -g; v--)
        if (u.value.lazyLoadedList.indexOf(v) < 0) {
          i.push(v);
          break;
        }
      i.length > 0 ? (u.value.lazyLoadedList = u.value.lazyLoadedList.concat(i), n("lazyLoad", i)) : G && (clearInterval(G), G = null);
    }, mt = () => {
      var g;
      const i = (g = E.value) == null ? void 0 : g.querySelectorAll(
        ".v-slick-slide-group img"
      ), o = (i == null ? void 0 : i.length) || 0;
      let p = 0;
      i == null || i.forEach((v) => {
        const b = () => {
          ++p >= o && J();
        };
        if (!v.onclick)
          v.onclick = () => {
            var z;
            (z = v.closest(".v-slick-slide-group")) == null || z.focus();
          };
        else {
          const z = v.onclick.bind(v);
          v.onclick = (C) => {
            var V;
            z(C), (V = v.closest(".v-slick-slide-group")) == null || V.focus();
          };
        }
        if (v.onload)
          v.onload = b, v.onerror = () => {
            b(), n("lazyLoadError");
          };
        else {
          if (!r.value.lazyLoad) return;
          v.onload = () => {
            j(), h.push(setTimeout(J, r.value.speed));
          };
        }
      });
    }, Re = async () => (u.value.detectingWidth = !0, new Promise(
      (i) => setTimeout(() => {
        var o;
        Object.assign(_e.value, {
          width: `${(o = Ve.value) == null ? void 0 : o.offsetWidth}px`
        }), u.value.detectingWidth = !1, i();
      })
    )), kt = () => {
      const i = {
        ...r.value,
        ...u.value,
        slideGroupCount: x.value
      }, o = Z(i), p = Ne(i);
      if (r.value.variableWidth) {
        let g = [], v = [];
        const b = [];
        qe.value.forEach((C) => {
          let V = 0;
          C.forEach((ye) => {
            var te;
            const { width: ne } = ((te = ye.props) == null ? void 0 : te.style) || {};
            ne && (V = Math.max(V, ne));
          }), b.push(V), g.push(V);
        });
        for (let C = 0; C < o; C++)
          v.push(b[b.length - 1 - C]), g.push(b[b.length - 1 - C]);
        for (let C = 0; C < p; C++)
          g.push(b[C]);
        for (let C = 0; C < u.value.currentSlideGroupIndex; C++)
          v.push(b[C]);
        g = g.filter((C) => C), v = v.filter((C) => C);
        const z = {
          width: `calc(${g.join(" + ")})`,
          left: `calc(${v.map((C) => `-${C}`).join(" + ")})`
        };
        if (r.value.centerMode) {
          const C = b[u.value.currentSlideGroupIndex];
          z.left = `calc(${v.map((V) => `-${V}`).join(" + ")} + (100% - ${C}) / 2 )`;
        }
        u.value.trackStyle = z;
      } else {
        const g = o + p + x.value, v = 100 / r.value.groupsToShow * g, b = 100 / g;
        let z = -b * (o + u.value.currentSlideGroupIndex) * v / 100;
        r.value.centerMode && (z += (100 - b * v / 100) / 2), u.value.slideGroupWidth = b + "%", u.value.trackStyle = {
          width: v + "%",
          left: z + "%"
        };
      }
    }, ge = F(), Ve = F(), _e = F({}), E = F(), q = F(), r = N(() => {
      const i = et(a);
      let o = { ...Jt, ...i };
      if (ge.value) {
        const p = a.responsive.find(
          (g) => g.breakpoint === ge.value
        );
        o = {
          ...o,
          ...p == null ? void 0 : p.settings
        };
      }
      return o.centerMode && (o.groupsToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn(
        `centerMode is enabled: groupsToScroll should be 1; you are using ${o.groupsToScroll}`
      ), o.groupsToScroll = 1, o.infinite && (o.infiniteLoopOnEdge = !0)), o.fade && (o.groupsToShow > 1 && process.env.NODE_ENV !== "production" && console.warn(
        `fade is enabled: groupsToShow should be 1; you are using ${o.groupsToShow}`
      ), o.groupsToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn(
        `fade is enabled: groupsToScroll should be 1; you are using ${o.groupsToScroll}`
      ), o.groupsToShow = 1, o.groupsToScroll = 1), o.infiniteLoopOnEdge && (!o.infinite && process.env.NODE_ENV !== "production" && console.warn(
        "infiniteLoopOnEdge is enabled: infinite needs to be enabled for this option to work"
      ), o.groupsToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn(
        `infiniteLoopOnEdge is enabled: groupsToScroll needs to be 1 for this option to work; you are using ${o.groupsToScroll}`
      )), o.slidesPerGroup > 1 && (o.variableWidth && process.env.NODE_ENV !== "production" && console.warn("slidesPerGroup is bigger than 1: variableWidth is disabled"), o.variableWidth = !1), o.vertical && o.rtl && (process.env.NODE_ENV !== "production" && console.warn("vertical mode is enabled: rtl is disabled"), o.rtl = !1), o.groupsToScroll > o.groupsToShow && (process.env.NODE_ENV !== "production" && console.warn(
        `groupsToScroll (${o.groupsToScroll}) can be at most groupsToShow (${o.groupsToShow})`
      ), o.groupsToScroll = o.groupsToShow), o.unslick && (o.dots = !1, o.arrows = !1, o.autoplay = !1, o.infinite = !1, o.draggable = !1, o.fade = !1, o.centerMode = !1), o;
    }), je = N(
      () => r.value.infinite && (r.value.infiniteLoopOnEdge && x.value >= r.value.groupsToShow || x.value > r.value.groupsToShow) || Se.value > 0
    ), ie = N(
      () => r.value.infinite && (r.value.infiniteLoopOnEdge && x.value >= r.value.groupsToShow || x.value > r.value.groupsToShow) || ee.value > Se.value + 1
    ), he = F(s.default ? ze(s.default()) : []), u = F({
      ...er(),
      currentSlideGroupIndex: r.value.initialGroupIndex
    }), Xe = N(
      () => u.value.currentSlideGroupIndex
    ), Gt = N(() => r.value.groupsToShow), x = N(
      () => at(he.value.length, r.value.slidesPerGroup)
    ), ee = N(() => r.value.infinite && r.value.infiniteLoopOnEdge && r.value.groupsToScroll === 1 && x.value >= r.value.groupsToShow ? x.value : Math.ceil(
      Math.max(
        x.value - r.value.groupsToShow + (r.value.centerMode ? r.value.infinite ? r.value.groupsToShow - 1 : Math.floor(r.value.groupsToShow / 2) : 0),
        0
      ) / r.value.groupsToScroll
    ) + 1), Ye = N(() => Array.from({ length: ee.value }, (i, o) => {
      if (o !== ee.value - 1 || r.value.infinite && (r.value.centerMode || r.value.infiniteLoopOnEdge))
        return o * r.value.groupsToScroll;
      const p = (x.value - (o - 1) * r.value.groupsToScroll) % r.value.groupsToShow;
      return p === 0 ? o * r.value.groupsToScroll : (o - 1) * r.value.groupsToScroll + p;
    })), Se = N(() => {
      const i = Ye.value.findIndex(
        (o) => o > Xe.value
      );
      return i === -1 ? ee.value - 1 : i - 1;
    }), qe = N(() => {
      const i = [], o = r.value.slidesPerGroup, p = x.value;
      for (let g = 0; g < p; g++) {
        const v = g * o, b = v + o;
        i.push(he.value.slice(v, b));
      }
      return i;
    });
    return ae(
      () => a.responsive,
      () => {
        y(), I();
      },
      { deep: !0 }
    ), ae(
      r,
      (i, o) => {
        let p = !1;
        for (const g of Object.keys(r.value)) {
          if (!i.hasOwnProperty(g)) {
            p = !0;
            break;
          }
          if (!(typeof i[g] == "object" || typeof i[g] == "function") && i[g] !== o[g]) {
            p = !0;
            break;
          }
        }
        xe(p), u.value.currentSlideGroupIndex >= x.value && Y({
          message: "index",
          index: x.value - i.groupsToShow
        }), i.autoplay ? H(T.play) : O(T.paused);
      },
      {
        deep: !0
      }
    ), ae(
      () => {
        var i;
        return ((i = s.default) == null ? void 0 : i.call(s)) || [];
      },
      (i) => {
        he.value = ze(i);
      }
    ), ae(
      () => [
        u.value.listHeight,
        r.value.centerMode,
        r.value.centerPadding,
        r.value.vertical
      ],
      ([i, o, p, g]) => {
        let v = {
          height: "auto"
        };
        g && (v = {
          height: `${i}px`
        });
        let b;
        o ? g ? b = {
          padding: p + " 0px"
        } : b = {
          padding: "0px " + p
        } : b = {
          padding: "0"
        }, S.value = {
          ...S.value,
          ...et(v),
          ...b
        };
      }
    ), ae(
      () => u.value.dragging,
      (i) => {
        E.value && (i ? (E.value.onmousemove = Te, E.value.addEventListener(
          "touchmove",
          Te,
          { passive: !1 }
        ), E.value.onmouseup = Le, E.value.addEventListener(
          "touchend",
          Le,
          { passive: !1 }
        ), E.value.onmouseleave = be, E.value.addEventListener(
          "touchcancel",
          be,
          { passive: !1 }
        )) : (E.value.onmousemove = null, E.value.removeEventListener(
          "touchmove",
          Te
        ), E.value.onmouseup = null, E.value.removeEventListener(
          "touchend",
          Le
        ), E.value.onmouseleave = null, E.value.removeEventListener(
          "touchcancel",
          be
        )));
      }
    ), l({
      goTo: ve,
      next: () => Y({ message: W.next }),
      prev: () => Y({ message: W.previous }),
      canGoNext: ie,
      canGoPrev: je,
      play: R,
      pause: O,
      autoPlay: H,
      slideGroupCount: x,
      currentSlideGroupIndex: Xe,
      currentGroupsToShow: Gt,
      pageCount: ee
    }), Et(async () => {
      var i;
      window.addEventListener("resize", Be), r.value.widthDetection === re.manual && await Re(), xe(!0), j(), r.value.autoplay && H(T.update), r.value.lazyLoad === rt.progressive && (G = setInterval(wt, 1e3)), f = new ResizeObserver(() => {
        u.value.animating ? (J({ shouldSetTrackStyle: !1 }), h.push(setTimeout(() => J(), r.value.speed))) : J();
      }), f.observe(E.value), (i = E.value) == null || i.querySelectorAll(".v-slick-slide-group").forEach((o) => {
        o.onfocus = r.value.pauseOnFocus ? St : null, o.onblur = r.value.pauseOnFocus ? yt : null;
      });
    }), Mt(() => {
      if (mt(), n("reInit"), r.value.lazyLoad) {
        const i = De({
          ...r.value,
          ...u.value
        });
        i.length && (u.value.lazyLoadedList = u.value.lazyLoadedList.concat(i), n("lazyLoad", i));
      }
      j();
    }), Ot(() => {
      window.removeEventListener("resize", Be), f == null || f.unobserve(E.value), L && clearTimeout(L), G && clearInterval(G), h.length && (h.forEach((i) => clearTimeout(i)), h = []), u.value.autoplayTimer && clearInterval(u.value.autoplayTimer);
    }), I(), kt(), n("init"), (i, o) => ($(), P("div", {
      ref_key: "vSlickCarouselRef",
      ref: Ve,
      class: "v-slick-carousel",
      style: $e(
        i.widthDetection === we(re).manual ? u.value.detectingWidth ? { width: "100%" } : _e.value : {}
      )
    }, [
      de("div", {
        class: "v-slick-slider",
        dir: r.value.rtl ? "rtl" : "ltr"
      }, [
        r.value.arrows && !r.value.unslick ? ($(), le(tt, {
          key: 0,
          type: we(W).previous,
          "center-mode": r.value.centerMode,
          infinite: r.value.infinite,
          "groups-to-show": r.value.groupsToShow,
          "slide-group-count": x.value,
          "current-slide-group-index": u.value.currentSlideGroupIndex,
          disabled: !je.value,
          onPrevious: gt
        }, {
          prevArrow: Ie((p) => [
            oe(i.$slots, "prevArrow", ue(Ee(p)), void 0, !0)
          ]),
          _: 3
        }, 8, ["type", "center-mode", "infinite", "groups-to-show", "slide-group-count", "current-slide-group-index", "disabled"])) : Me("", !0),
        de("div", {
          ref_key: "vSlickListRef",
          ref: E,
          class: ce(["v-slick-list", { dragging: u.value.dragging }]),
          style: $e(S.value),
          onClick: U,
          onMousedown: Ae,
          onTouchstartPassive: Ae,
          onKeydown: st
        }, [
          $t(sr, {
            ref_key: "vSlickTrackRef",
            ref: q,
            "center-mode": r.value.centerMode,
            "center-padding": r.value.centerPadding,
            "raw-slide-groups": qe.value,
            "css-ease": i.cssEase,
            "current-slide-group-index": u.value.currentSlideGroupIndex,
            "detecting-width": u.value.detectingWidth,
            fade: r.value.fade,
            "ignore-prefers-reduced-motion": r.value.ignorePrefersReducedMotion,
            infinite: r.value.infinite,
            "infinite-loop-on-edge": r.value.infiniteLoopOnEdge,
            "lazy-load": r.value.lazyLoad,
            "lazy-loaded-list": u.value.lazyLoadedList,
            "list-height": u.value.listHeight,
            rtl: r.value.rtl,
            "slide-group-count": x.value,
            "slide-group-height": u.value.slideGroupHeight,
            "slide-group-width": u.value.slideGroupWidth,
            "groups-to-scroll": r.value.groupsToScroll,
            "groups-to-show": r.value.groupsToShow,
            speed: r.value.speed,
            "track-style": u.value.trackStyle,
            "variable-width": r.value.variableWidth,
            vertical: r.value.vertical,
            onMouseenter: He,
            onMouseleave: dt,
            onMouseover: He,
            onChildClick: ut
          }, null, 8, ["center-mode", "center-padding", "raw-slide-groups", "css-ease", "current-slide-group-index", "detecting-width", "fade", "ignore-prefers-reduced-motion", "infinite", "infinite-loop-on-edge", "lazy-load", "lazy-loaded-list", "list-height", "rtl", "slide-group-count", "slide-group-height", "slide-group-width", "groups-to-scroll", "groups-to-show", "speed", "track-style", "variable-width", "vertical"])
        ], 38),
        r.value.arrows && !r.value.unslick ? ($(), le(tt, {
          key: 1,
          type: we(W).next,
          "center-mode": r.value.centerMode,
          infinite: r.value.infinite,
          "groups-to-show": r.value.groupsToShow,
          "slide-group-count": x.value,
          "current-slide-group-index": u.value.currentSlideGroupIndex,
          disabled: !ie.value,
          onNext: vt
        }, {
          nextArrow: Ie((p) => [
            oe(i.$slots, "nextArrow", ue(Ee(p)), void 0, !0)
          ]),
          _: 3
        }, 8, ["type", "center-mode", "infinite", "groups-to-show", "slide-group-count", "current-slide-group-index", "disabled"])) : Me("", !0)
      ], 8, fr),
      r.value.dots && !r.value.unslick ? ($(), le(cr, {
        key: 0,
        "current-slide-group-index": u.value.currentSlideGroupIndex,
        infinite: r.value.infinite,
        "slide-group-count": x.value,
        "groups-to-scroll": r.value.groupsToScroll,
        "groups-to-show": r.value.groupsToShow,
        "page-count": ee.value,
        "current-page": Se.value,
        onDotClick: pt,
        onDotsOver: ct,
        onDotsLeave: ft
      }, {
        customPaging: Ie((p) => [
          oe(i.$slots, "customPaging", ue(Ee(p)), void 0, !0)
        ]),
        _: 3
      }, 8, ["current-slide-group-index", "infinite", "slide-group-count", "groups-to-scroll", "groups-to-show", "page-count", "current-page"])) : Me("", !0)
    ], 4));
  }
}), Sr = /* @__PURE__ */ Pe(vr, [["__scopeId", "data-v-c0f18f92"]]);
export {
  rt as LazyLoadType,
  T as PlayingType,
  W as SlideNavigation,
  A as SwipeDirection,
  Sr as VSlickCarousel,
  re as WidthDetection
};
//# sourceMappingURL=index.es.mjs.map
